import React, { useState } from 'react';
import {
	Button,
	Paper,
	Box,
	Typography,
	Grid,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	TextField,
} from '@mui/material';

import { useSnackbar } from '../../context/SnackBarContext';
import { crearUbicacion } from '../../services/ubicacion.service';

const token = JSON.parse(localStorage.getItem('colaborador'));

export default function Ubicaciones() {
	const [selectedCity, setSelectedCity] = useState('');
	const [ubicationName, setUbicationName] = useState('');

	const { showSnackbar } = useSnackbar();

	// ✅ Corregido: recibe el evento completo, no el target
	const handleChange = (e) => {
		setSelectedCity(e.target.value);
	};

	const ciudades = [
		{ id_ciudad: 1, nombre_ciudad: 'La Paz' },
		{ id_ciudad: 2, nombre_ciudad: 'Cochabamba' },
		{ id_ciudad: 3, nombre_ciudad: 'Santa Cruz' },
	];

	const registerNewUbication = async () => {
		const data = {
			nombre_ubicacion: ubicationName,
			id_ciudad: selectedCity,
			id_tipo_ubicacion: 3, // Transportadora
		};

		console.log('Token enviado:', token);
		console.log('Datos a enviar:', data);

		try {
			const res = await crearUbicacion(data);
			setSelectedCity('');
			setUbicationName('');
			showSnackbar({
				message: res.data.message || 'Transportadora registrada correctamente',
				severity: 'success',
			});
		} catch (err) {
			const message =
				err.response?.data?.message || 'Error al crear la transportadora';
			showSnackbar({ message, severity: 'error' });
		}
	};

	return (
		<Grid item>
			<Paper elevation={3} sx={{ padding: 2 }}>
				<Typography align='center' variant='h6'>
					Registro de transportadora
				</Typography>

				<Box display='flex' justifyContent='space-around' alignItems='center' gap={2}>
					<TextField
						onChange={(e) => setUbicationName(e.target.value)}
						label='Nombre de la transportadora'
						value={ubicationName}
					/>

					<FormControl style={{ width: '300px' }}>
						<InputLabel id='city'>Ciudad</InputLabel>
						<Select
							labelId='city'
							id='city'
							value={selectedCity}
							label='Ciudad'
							name='id_ciudad'
							onChange={handleChange} // ✅ aquí está el cambio
						>
							{ciudades.map((ciudad) => (
								<MenuItem key={ciudad.id_ciudad} value={ciudad.id_ciudad}>
									{ciudad.nombre_ciudad}
								</MenuItem>
							))}
						</Select>
					</FormControl>

					<Button
						onClick={registerNewUbication}
						variant='contained'
						disabled={!ubicationName || !selectedCity} // ⚡ Evita clicks vacíos
					>
						Registrar nueva transportadora
					</Button>
				</Box>
			</Paper>
		</Grid>
	);
}
